import {HTTP_SERVICE_INSTANCE} from '@/services/http.service';
import {AxiosRequestConfig} from 'axios';
import {URL_SERVICE_INSTANCE} from '@/services/url.service';
import {LazySearchProvider} from '@/services/datatable/lazy-datatable-search-provider.service';
import {LocalSearchProvider} from '@/services/datatable/local-datatable-search-provider.service';
import {SearchProvider} from './abstract-datatable-search-provider.service';
import DTTemplateDto = DisguiseDto.DTTemplateDto;

interface DataProviderDataResponse {
    data: DTTemplateDto;
    page: number;
    size: number;
    maxSize: number;
    totalPages: number;
}

interface TableAccessConfig {
    searchProvider: SearchProvider;
}

/**
 * Data table service to access API
 */
class DataTableService {

    /**
     * Returns an AXIOS Promise that returns the table data
     * TODO: Swtich all DT's to POST instead of increasing header size.
     */
    loadTable(templateUrl: string,
              inputConfig: DisguiseDto.DTInputConfigurationDto,
              requestConfig?: AxiosRequestConfig) {
        // URL
        const apiPath = `${templateUrl}`;
        const apiURL = apiPath + (apiPath.indexOf('?') > 0 ? '&' : '?') + URL_SERVICE_INSTANCE.serialize(inputConfig);

        return HTTP_SERVICE_INSTANCE.getAxios()
          .get<DisguiseDto.DTTemplateDto>(apiURL, requestConfig);
    }

    /**
     * Depending on the .lazyLoading field of the datatable api response, it will return
     *  the correct search provider instance. Either lazy or local search provider.
     */
    getTableConfig(templateUrl: string,
                   inputConfig: DisguiseDto.DTInputConfigurationDto): Promise<TableAccessConfig> {
        return new Promise((resolve, reject) => {

            this.loadTable(templateUrl, inputConfig).then((response) => {
                const table: DisguiseDto.DTTemplateDto = response.data;

                let searchProvider;
                if (table.lazyLoading) {
                    searchProvider = new LazySearchProvider(templateUrl, table, inputConfig);
                } else {
                    searchProvider = new LocalSearchProvider(templateUrl, table, inputConfig);
                }

                resolve({
                    searchProvider
                });
            }, (error) => {
                reject(error);
            });
        });
    }
}

const DATATABLE_SERVICE_INSTANCE = new DataTableService();

export {
    DATATABLE_SERVICE_INSTANCE, TableAccessConfig, DataProviderDataResponse
};
